import { colors } from '@/theme/colors';

export default function Insurance() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.125 9.75C4.02554 9.75 3.93016 9.78951 3.85983 9.85983C3.78951 9.93016 3.75 10.0255 3.75 10.125"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 10.125C4.5 10.0255 4.46049 9.93016 4.39016 9.85983C4.31984 9.78951 4.22446 9.75 4.125 9.75"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.125 10.5C4.22446 10.5 4.31984 10.4605 4.39016 10.3902C4.46049 10.3198 4.5 10.2245 4.5 10.125"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 10.125C3.75 10.2245 3.78951 10.3198 3.85983 10.3902C3.93016 10.4605 4.02554 10.5 4.125 10.5"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.4305 14.8571C22.4337 16.5205 21.8691 18.1351 20.83 19.4339C19.791 20.7327 18.3397 21.638 16.7162 22C15.0928 21.638 13.6415 20.7327 12.6024 19.4339C11.5633 18.1351 10.9987 16.5205 11.0019 14.8571V12.7143C11.0019 12.3354 11.1524 11.972 11.4204 11.7041C11.6883 11.4362 12.0516 11.2857 12.4305 11.2857H21.0019C21.3808 11.2857 21.7442 11.4362 22.0121 11.7041C22.28 11.972 22.4305 12.3354 22.4305 12.7143V14.8571Z"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 12L21.6667 17.6667"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13L18.6667 19.6667"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.09808 7.10286L4.7638 3.39048C4.91697 2.98162 5.19143 2.62933 5.55042 2.38082C5.9094 2.1323 6.33576 1.99943 6.77237 2H15.2314C15.668 1.9997 16.0942 2.13268 16.4531 2.38116C16.8121 2.62964 17.0866 2.98177 17.24 3.39048L18.9067 7.10476"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14V15.8594C2 16.2945 2.21071 16.7118 2.58579 17.0195C2.96086 17.3271 3.46957 17.5 4 17.5C4.53043 17.5 5.03914 17.3271 5.41421 17.0195C5.78929 16.7118 6 16.2945 6 15.8594V14.2187"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.619 8.42857C20.3681 7.99396 20.0072 7.63311 19.5725 7.38233C19.1378 7.13154 18.6447 6.99968 18.1429 7H3.85714C3.09938 7 2.37266 7.30102 1.83684 7.83684C1.30102 8.37266 1 9.09938 1 9.85714V12C1 12.3789 1.15051 12.7422 1.41842 13.0102C1.68633 13.2781 2.04969 13.4286 2.42857 13.4286H8.14286"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
